import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
function itemTag(item) {
    return item.as ?? (item.href !== undefined ? "a" : "button");
}
// `withIcon` is true for the inline bar (icons are an inline-nav affordance) and
// false for the collapsed dropdown, which speaks plain menu language — labels only,
// the current row marked by the trailing sky tick (see `.fwfa-topnav-pop` CSS).
function renderItem(item, index, className, withIcon, onSelect) {
    const tag = itemTag(item);
    const current = item.active ? "page" : undefined;
    const handleClick = (event) => {
        onSelect?.(event);
        item.onClick?.(event);
    };
    const body = (_jsxs(_Fragment, { children: [withIcon && item.icon != null && (_jsx("span", { className: "fwfa-icon", "aria-hidden": "true", children: item.icon })), item.label] }));
    if (tag === "a") {
        return (_jsx("a", { className: className, href: item.href, "aria-current": current, onClick: handleClick, children: body }, index));
    }
    return (_jsx("button", { type: "button", className: className, "aria-current": current, onClick: handleClick, children: body }, index));
}
// Native <details> close: collapse the disclosure after a menu pick (link
// navigation would unmount anyway, but SPA/button items need the explicit close).
function closeDisclosure(event) {
    event.currentTarget.closest("details")?.removeAttribute("open");
}
export function TopNav({ items, collapsedLabel, variant = "bar", className, ...rest }) {
    const { "aria-label": ariaLabel = "Primary", ...navRest } = rest;
    const activeLabel = items.find((item) => item.active)?.label ?? collapsedLabel ?? "Menu";
    return (_jsxs("nav", { className: cn("fwfa-topnav", variant === "section" && "fwfa-topnav--section", className), "aria-label": ariaLabel, ...navRest, children: [_jsx("ul", { className: "fwfa-topnav-list", children: items.map((item, index) => (_jsx("li", { children: renderItem(item, index, "fwfa-topnav-item", true) }, index))) }), _jsxs("details", { className: "fwfa-topnav-collapse", children: [_jsxs("summary", { className: "fwfa-topnav-trigger", children: [activeLabel, _jsx("span", { className: "fwfa-topnav-caret", "aria-hidden": "true" })] }), _jsx("div", { className: "fwfa-topnav-pop fwfa-menu", children: items.map((item, index) => renderItem(item, index, "fwfa-menu-item", false, closeDisclosure)) })] })] }));
}
//# sourceMappingURL=TopNav.js.map